module.exports = __webpack_public_path__ + "img/join-icon.e3f4a7ec.svg";